// extracted by mini-css-extract-plugin
export default {"payMethods":"style_payMethods__zhT29","container":"style_container__U6CJq","spinner":"style_spinner__qeidN"};